import {Ref, ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {GenericParamOptionsMenuEntryMultiSelect} from '../../../widgets/form/ExtendedParamOptionMenuEntry';
interface Options {
	attribNames: Ref<string[]>;
}

export function SetupSelectedAttributes(options: Options) {
	const {attribNames} = options;
	const attrib_selected_states_by_name = ref<PolyDictionary<boolean>>({});

	const attributesSelectInputDisplayedName = computed(
		() =>
			`${selectedAttributeNames.value.length}/${attribNames.value.length} ${
				attribNames.value.length == 1 ? 'attribute' : 'attributes'
			}`
	);
	const attributesSelectEntries = computed(() => {
		return attribNames.value.map((attribName) => {
			let selected = attrib_selected_states_by_name.value[attribName];
			if (selected == null) {
				selected = true;
			}
			const entry: GenericParamOptionsMenuEntryMultiSelect<string> = {
				name: attribName,
				value: attribName,
				selected,
			};
			return entry;
		});
	});
	const selectedAttributeNames = computed(() => {
		return attribNames.value.filter((attribName) => {
			let selected = attrib_selected_states_by_name.value[attribName];
			if (selected == null) {
				selected = true;
			}

			return selected;
		});
	});

	function attributesSelectInputToggleAttribute(entry: GenericParamOptionsMenuEntryMultiSelect<any>) {
		const attribName = entry.value;
		if (attrib_selected_states_by_name.value[attribName] == null) {
			attrib_selected_states_by_name.value[attribName] = false;
		} else {
			const inverted_selection = !attrib_selected_states_by_name.value[attribName];
			attrib_selected_states_by_name.value[attribName] = inverted_selection;
		}
	}
	function attributesSelectInputSelectAll() {
		for (let attrib_name of attribNames.value) {
			attrib_selected_states_by_name.value[attrib_name] = true;
		}
	}
	function attributesSelectInputSelectNone() {
		for (let attrib_name of attribNames.value) {
			attrib_selected_states_by_name.value[attrib_name] = false;
		}
	}
	const attribSelectedStates = computed(() => {
		const states: PolyDictionary<boolean> = {};

		for (let attrib_name of attribNames.value) {
			states[attrib_name] = attrib_selected_states_by_name.value[attrib_name];
			if (states[attrib_name] == null) {
				states[attrib_name] = true;
			}
		}
		return states;
	});

	return {
		attributesSelectInputDisplayedName,
		attributesSelectInputToggleAttribute,
		attributesSelectInputSelectAll,
		attributesSelectInputSelectNone,
		attribSelectedStates,
		attributesSelectEntries,
	};
}
